import { listProductIds } from '@/js/helpers/buy-request'
import { RogueOrder } from '@orders'
import { useProductStore } from '@/js/stores/productStore'
import type { IRogue } from '@/js/services/RogueTypes'

/**
 * Reload the product data to check for any inventory changes to cart products
 */
export async function reloadCartFromNet(rogue: IRogue, order: RogueOrder): Promise<void> {
  const productStore = useProductStore(rogue.pinia)
  const items = order.data.items || []

  // Reload all simple products from the net
  const reloads = listProductIds(items, true)
    .filter(productId => !!productStore.products[productId])
    .map(id => productStore.reload(id, false, rogue))

  const results = await Promise.all(reloads)
  // Results will return `true` if there were changes to the product. If any changed, we need to check for OOS items
  if (results.indexOf(true) !== -1) {
    await order.checkShippingRates()
  }
}
